<template>
	<div class="row">
		<div class="col-12">
			<div>
				<card title="Employees" :subTitle="'Total: '+(employees.length).toString()">
					<template slot="command">
						<p-button icon round type="link" :loading="loading" @click.native.prevent="loadEmployees"><i class="ti-reload"></i></p-button>
						<router-link to="employees/new"><p-button round class="btn btn-success">Add</p-button></router-link>
					</template>
					<div class="row mb-3">
						<div class="col-xl-4">
							<b-form-input autocomplete='off' v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<b-table responsive striped hover :filterIncludedFields="filterOn" :filter="filter" :per-page="num_for_page" :current-page="currentPage" 
							:items="employees" :fields="columns" :busy='loading' @filtered="onFiltered" show-empty>
								<template v-slot:table-busy>
									<loader :loading="loading"></loader>
								</template>
								<template v-slot:cell(full_name)="row">
									<router-link :to="'employees/'+row.item.id_employee">{{row.item.full_name}}</router-link>
									<br><small>{{getDepartment(row.item.departments)}}</small>
								</template>
								<template v-slot:cell(enabled)="row">
									<i v-if="row.item.enabled===1" class="ti-check"></i>
									<i v-if="row.item.enabled===0" class="ti-close"></i>
								</template>
							</b-table>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="num_for_page" align="right"></b-pagination>
						</div>
					</div>
				</card>
			</div>
		</div>
	
	</div>
</template>

<script>

export default {
	data(){
		return {
			loading:false,
			employees:[],
			columns: [
				{
					key: "id_employee",
					label: "#",
				},
				{
					key: "full_name",
					label:"Full name"
				},
				{
					key:'telephone_number',
					label:'Telephone'
				},
				{
					key:'veichle_number',
					label:'#Veichle'
				},
				{
					key:"slots",
					label:"Default slots"
				},
				{
					key:'enabled',
					label:'Enabled'
				}
			],
			filter:null,
			currentPage:1,
			num_for_page:5,
			totalRows:1,
			filterOn: []
		}
	},
	methods:{
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		getDepartment(dep){
			let str = '';
			for(let i=0;i<dep.length;i++){
				str+=dep[i].name;
				if(i!==dep.length-1){
					str+=','
				}
			}
			return str;
		},
		async loadEmployees(){
			this.loading = true;
			let result = await this.$api.get('employee?join=departments');
			this.employees = result.data.map(e=>{
				return{
					id_employee:e.id_employee,
					full_name:e.first_name+' '+e.last_name,
					telephone_number:e.telephone_number,
					veichle_number:e.veichle_number,
					slots:e.slots,
					departments:e.departments,
					enabled:e.enabled
				}
			});
			this.loading = false;
		}
	},
	async beforeMount(){
		await this.loadEmployees();
		this.totalRows = this.employees.length;
	}
}
</script>

<style>
</style>
